import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUser, deleteUser, setToken } from "../../react-redux/Slicer/userSlice";
import { getData } from "../../FetchApiServices";
import Loader from "../Assets/Loader";

// Plot OS SSO handoff receiver (guide §9, fragment strategy).
// The backend /login/app_sso already minted OUR session and redirected here
// with the token in the URL FRAGMENT (never sent to any server). We store it
// exactly like a normal password login, then land the user in the T2T module.

// Same whitelist the backend enforces on `dest` — re-validate client-side too.
const safeDest = (d) =>
  d && /^[A-Za-z0-9_\-/]+$/.test(d) && !d.startsWith("/") && !d.includes("..") ? d : "";

const SsoCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode double-invoke
    ran.current = true;

    (async () => {
      const raw = window.location.hash || "";
      const params = new URLSearchParams(raw.startsWith("#") ? raw.slice(1) : raw);
      const token = params.get("token");
      const refresh = params.get("refresh");
      const uid = params.get("uid");
      const dest = safeDest(params.get("dest"));

      // Scrub the token from the address bar / history immediately.
      window.history.replaceState(null, "", window.location.pathname);

      if (!token) {
        navigate("/?sso_error=missing_token", { replace: true });
        return;
      }

      // Mirror the password-login success path (see Login.js handleSubmit).
      localStorage.clear();
      dispatch(deleteUser());
      localStorage.setItem("login_type", "t2t");
      dispatch(setToken(token)); // also writes localStorage['token']
      if (refresh) localStorage.setItem("refreshToken", refresh);

      const target = dest ? `/${dest}` : "/t2t-home";

      // Populate the Redux user object like login does (best-effort — token is
      // already set, so the app is authenticated even if this fetch fails).
      try {
        if (uid) {
          const userResp = await getData(`users/${uid}`);
          const data = userResp?.data?.data;
          if (data) dispatch(addUser(Array.isArray(data) ? data[0] : data));
        }
      } catch (e) {
        console.error("[plot-os] post-SSO user fetch failed:", e);
      }

      navigate(target, { replace: true });
    })();
  }, [dispatch, navigate]);

  return <Loader />;
};

export default SsoCallback;
